export const AVATAR_INITIALS_LARGE_MIN_SIZE = 64;
export const AVATAR_INITIALS_MEDIUM_MIN_SIZE = 44;

export const AVATAR_INITIALS_VARIANT = {
  LARGE: 'regular32',
  MEDIUM: 'regular24',
  DEFAULT: 'regular14',
};
